(function() {
    'use strict';

    angular.module('app.choferes', []);
})();
